module.exports = __webpack_public_path__ + "static/img/sec 9.fa9a6fd.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/spark-mini/sec 9.png
// module id = e7Gv
// module chunks = 12